import Switch from '@mui/material/Switch';
import {withStyles} from '@mui/styles';
import React from 'react';
import {theme} from '../../Theme';

interface IProps {
  checked: boolean;
  onChange: any;
}

const StyledSwitch = withStyles({
  switchBase: {
    color: theme.palette.gray.main,
    '&$checked': {
      color: theme.palette.blue.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.blue.main,
    },
    '&$checked + $thumb': {
      backgroundColor: theme.palette.blue.main,
    },
  },
  checked: {},
  track: {},
})(Switch);

export default function BidmiiSwitch(props: IProps) {
  return (
    <StyledSwitch
      color="default"
      checked={props.checked}
      onChange={props.onChange}
    />
  );
}
